import { render, staticRenderFns } from "./UserEkspedisiTambah.vue?vue&type=template&id=038b6f5d&scoped=true&"
import script from "./UserEkspedisiTambah.vue?vue&type=script&lang=js&"
export * from "./UserEkspedisiTambah.vue?vue&type=script&lang=js&"
import style0 from "./UserEkspedisiTambah.vue?vue&type=style&index=0&id=038b6f5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038b6f5d",
  null
  
)

export default component.exports